
import { controls } from "../../controls"

const ms217 = {
  label: "Link Account To AAdharUID",
  pageLabel: "Link Account To AAdharUID",
  starting: true,
  url: "ms217",
  pageType: "history",
  formActions: { edit: { allow: true } },
  formTabs: {
    allTabs: [
      {
        label: "Create",
        uid: "create",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  filter: [
    ...controls.displayText({ tab: "filter", star: true, label: "Parent Branch", widths: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isRequired: true, defaultValue: "assigned_branch" }),

    ...controls.showData({ tab: "filter", data: "branch_display", isRequired: true, name: "branch_display", }),

    ...controls.displayText({ tab: "filter", width: "col-sm-6" }),
    ...controls.displayText({ tab: "filter", star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", isRequired: true, width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", width: "col-sm-2", data: "product_code_display", name: "product_code_display" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),

    ...controls.displayText({ tab: "filter", label: "Number Of Records", width: "col-sm-2" }),
    ...controls.numberOnly({ tab: "filter", name: "per_page", placeHolder: "Enter Number Of Records", width: "col-sm-2" }),


  ],
  form: [
    ...controls.displayText({ tab: "create", label: "AADHAR UID", width: "col-sm-2" }),
    ...controls.aadharNumber({ tab: "create", isRequired: true, width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", label: "", width: "col-sm-2" }),
    ...controls.button({
      label: "Check CIN", onclick: {
        action: [{ act: "checkAAdharUID", sendToServer: { dataType: "unlinkUID", sendData: [{ varname: 'aadhaar_id', value: 'aadhaar_id' }] } }],
      }, width: "col-sm-1",
      style: { padding: 0 },
      Bcolor: "success"
    }),

    ...controls.product({ tab: "filter", isRequired: true, width: "col-sm-2", sendToServer: { dataType: 'product', sendData: [{ varname: 'product_group', fixed: "Deposit" }] } }),


    ...controls.showData({ tab: "create", data: 'unlink_message', width: "col-sm-5" }),

    ...controls.displayText({ star: true, tab: "create", label: "Customer Number", width: "col-sm-2" }),
    ...controls.customerNumber({
      displayData: { description: "customer_number_display", customer_number_guid: 'customer_number_guid', aadhar: "aadhar_id_on_file", }, isReadOnly: true, isRequired: true, tab: "create"
    }),
    ...controls.showData({ tab: "create", data: "customer_number_display", name: "customer_number_display", width: "col-sm-2", displaytype: 'titlecase' }),
    ...controls.displayText({ tab: "create", label: "", width: "col-sm-6" }),

    ...controls.displayText({ tab: "create", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: 'create', isReadOnly: 'edit', defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "create", data: "branch_display", name: "branch_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "create", width: "col-sm-5" }),

    ...controls.displayText({ tab: "create", star: true, label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: 'create', isReadOnly: 'edit', isRequired: true, }),
    ...controls.showData({ tab: "create", data: "product_code_display", name: "product_code_display", width: "col-sm-2" }),

    // ...controls.displayText({ tab: "create", width: "col-sm-3" }),
    ...controls.showData({
      width: "col-sm-6",
      tab: "create",
      data: "aadhaarMessage",
      // parents: [
      //   {
      //     name: ["branch_guid", "account_branch_guid"],
      //     match: "equal",
      //     reverse: true,
      //     show: 'readonly'
      //   }
      // ]
    }),


    ...controls.displayText({ star: true, tab: "create", label: "Account No", width: "col-sm-2" }),
    ...controls.AccountNumber({
      isRequired: true,
      tab: "create", beforeLeave: ["createAcNo"],
    }),
    ...controls.showData({ tab: "create", data: "account_number_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "create", label: "AADHAAR on File", width: "col-sm-4" }),
    ...controls.showData({ tab: "create", data: "aadhar_id_on_file", width: "col-sm-2" })
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "AADHAR",
        accessor: "aadhaar_uid",
        width: 150
      },
      {
        Header: "CIN",
        accessor: "customer_number",
        width: 150
      },
      {
        Header: "A/c No",
        accessor: "account_number"
      },
      {
        Header: "Name",
        accessor: "customer_number_display"
      }
    ]
  }
};

export default ms217;
